export function getTextPartsWithHighlights(text: string, matchIndices: [number, number][]) {
	const parts: Array<{ text: string; highlight: boolean }> = [];
	let lastIndex = 0;

	for (const [start, end] of matchIndices) {
		// Intentionally ignore single-letter matches to avoid visual clutter
		if (start === end) continue;

		if (start > lastIndex) {
			parts.push({ text: text.slice(lastIndex, start), highlight: false });
		}

		parts.push({ text: text.slice(start, end + 1), highlight: true });
		lastIndex = end + 1;
	}

	if (lastIndex < text.length) {
		parts.push({ text: text.slice(lastIndex), highlight: false });
	}

	return parts;
}
